// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header.css */
.header {
    background-color: var(--secondary);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.header-container {
    max-width: 80rem;
    margin: 0 auto;
    padding: 0 1rem;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 8rem;
}

.logo-text {
    font-size: 1.75rem;
    font-weight: bold;
    color: var(--white);
}

.nav-menu {
    display: none;
    gap: 2rem;
}

.nav-menu.mobile-menu-open {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 8rem;
    left: 0;
    right: 0;
    background-color: var(--secondary);
    padding: 1rem;
    z-index: 1000;
}

.nav-button, .login-button {
    color: var(--white);
    padding: 0.75rem 1rem;
    border-radius: 0.375rem;
    font-size: 1.3rem;
    font-weight: 500;
    transition: all 0.3s ease;
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: none;
    position: relative;
    overflow: hidden;
}

.nav-button::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--white);
    transform: scaleX(0);
    transform-origin: bottom right;
    transition: transform 0.3s ease;
}

.nav-button:hover::after {
    transform: scaleX(1);
    transform-origin: bottom left;
}

.nav-button:hover {
    transform: translateY(-2px);
}

.nav-button.active, .login-button.active {
    background-color: rgba(var(--white), 0.2);
    color: var(--white);
}

.login-button {
    background-color: var(--white);
    color: var(--black);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.3s ease;
}

.login-button:hover {
    background-color: var(--primary);
    transform: translateY(-2px);
}

.mobile-menu {
    display: block;
}

.mobile-menu-button {
    color: var(--white);
    padding: 0.5rem;
    background: none;
    border: none;
    cursor: pointer;
}

.menu-icon {
    height: 1.5rem;
    width: 1.5rem;
    color: var(--white);
}

@media (min-width: 768px) {
    .nav-menu {
        display: flex;
        flex-direction: row;
        position: static;
        background-color: transparent;
        padding: 0;
    }

    .mobile-menu {
        display: none;
    }

    .nav-menu.mobile-menu-open {
        display: flex;
        flex-direction: row;
        position: static;
        background-color: transparent;
        padding: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,kCAAkC;IAClC,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,oBAAoB;IACpB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,6BAA6B;QAC7B,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,6BAA6B;QAC7B,UAAU;IACd;AACJ","sourcesContent":["/* Header.css */\n.header {\n    background-color: var(--secondary);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.header-container {\n    max-width: 80rem;\n    margin: 0 auto;\n    padding: 0 1rem;\n}\n\n.header-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 8rem;\n}\n\n.logo-text {\n    font-size: 1.75rem;\n    font-weight: bold;\n    color: var(--white);\n}\n\n.nav-menu {\n    display: none;\n    gap: 2rem;\n}\n\n.nav-menu.mobile-menu-open {\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: 8rem;\n    left: 0;\n    right: 0;\n    background-color: var(--secondary);\n    padding: 1rem;\n    z-index: 1000;\n}\n\n.nav-button, .login-button {\n    color: var(--white);\n    padding: 0.75rem 1rem;\n    border-radius: 0.375rem;\n    font-size: 1.3rem;\n    font-weight: 500;\n    transition: all 0.3s ease;\n    background: none;\n    border: none;\n    cursor: pointer;\n    text-decoration: none;\n    position: relative;\n    overflow: hidden;\n}\n\n.nav-button::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: var(--white);\n    transform: scaleX(0);\n    transform-origin: bottom right;\n    transition: transform 0.3s ease;\n}\n\n.nav-button:hover::after {\n    transform: scaleX(1);\n    transform-origin: bottom left;\n}\n\n.nav-button:hover {\n    transform: translateY(-2px);\n}\n\n.nav-button.active, .login-button.active {\n    background-color: rgba(var(--white), 0.2);\n    color: var(--white);\n}\n\n.login-button {\n    background-color: var(--white);\n    color: var(--black);\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    transition: all 0.3s ease;\n}\n\n.login-button:hover {\n    background-color: var(--primary);\n    transform: translateY(-2px);\n}\n\n.mobile-menu {\n    display: block;\n}\n\n.mobile-menu-button {\n    color: var(--white);\n    padding: 0.5rem;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.menu-icon {\n    height: 1.5rem;\n    width: 1.5rem;\n    color: var(--white);\n}\n\n@media (min-width: 768px) {\n    .nav-menu {\n        display: flex;\n        flex-direction: row;\n        position: static;\n        background-color: transparent;\n        padding: 0;\n    }\n\n    .mobile-menu {\n        display: none;\n    }\n\n    .nav-menu.mobile-menu-open {\n        display: flex;\n        flex-direction: row;\n        position: static;\n        background-color: transparent;\n        padding: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
